// Polyfill for Promise.withResolvers, for yandex browser v23 and below, which is based on Chromium 85 and doesn't support it yet.
// https://gist.github.com/lmammino/ef121da874a80d657379a1cd64bf8166
// https://www.notion.so/BUG-4151-23-3435457f94c5801cb789ea04df32c7ef
if (typeof Promise.withResolvers === 'undefined') {
  Promise.withResolvers = function <T>() {
    let resolve!: (value: T | PromiseLike<T>) => void
    let reject!: (reason?: unknown) => void
    const promise = new Promise<T>((res, rej) => {
      resolve = res
      reject = rej
    })
    return { promise, resolve, reject }
  }
}

export type DeferredObject<T = unknown> = {
  resolve: (value?: T) => void
  reject: (value?: T) => void
  promise: Promise<T | undefined>
}

export const createDeferred = <T = unknown>(): DeferredObject<T> =>
  Promise.withResolvers<T | undefined>()
